import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import React from 'react';
import {App} from './app';
import {FeatureServicesContext} from './use-feature-services';
import {TrackingManagerV1} from '@volkswagen-onehub/tracking-service';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {Provider} from 'react-redux';
import {AppContextProvider} from './store/context/AppContext';
import {AppContext, FeatureAppConfig} from './AppContext';
import { store } from './store/store';
import { COMPONENTS_CORE_VERSION } from '@volkswagen-onehub/components-core';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'locale-service': LocaleServiceV1;
  readonly 'tracking': TrackingManagerV1;
  readonly 's2:logger'?: Logger;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies
> = {
  optionalDependencies: {
    featureServices: {
      'locale-service': '^1.1.0',
      'tracking': '^1.0.0',
      's2:logger': '^1.0.0',
      'layer-manager': '^2.0.0',
    },
  },

  create: ({config, featureServices}) => ({
    render() {
      return (
        <AppContext.Provider value={config as FeatureAppConfig}>
          <FeatureServicesContext.Provider value={featureServices}>
            <AppContextProvider>
              <Provider store={store}>
                <App />
              </Provider>
            </AppContextProvider>
          </FeatureServicesContext.Provider>
        </AppContext.Provider>
      );
    },
  }),
};

export default featureAppDefinition;

type VwcaDebug = {appComponentsCoreVersions?: Record<string, string>; printAppComponentsCoreVersions?(): void};
const w = window as unknown as {vwca: VwcaDebug};
w.vwca = w.vwca || {};
const appVersions: Record<string, string> = w.vwca.appComponentsCoreVersions = w.vwca.appComponentsCoreVersions || {};
// eslint-disable-next-line no-console
w.vwca.printAppComponentsCoreVersions = w.vwca.printAppComponentsCoreVersions || (() => console.table(appVersions));
appVersions['suvw-poll'] = COMPONENTS_CORE_VERSION;
